import React from "react"
import {Button} from "react-bootstrap"

function ProfileComplete(props: {step: number, getRealvrUser: any }) {
  const {step, getRealvrUser} = props

  if (step !== 3) return null;

  return (
    <section className="container main p-4 rounded profile-wizard">
      <div className="row">
        <div className="col text-center instructions">
          Hooray! Now go enjoy Villa
          <br/>
          on your headset!
          <br/>
          <br/>
        </div>
      </div>
      <div className="row">
        <div className="col text-center">
          <Button
            className="btn-50 next"
            onClick={getRealvrUser}
            variant="primary"
          >
            Continue
          </Button>
        </div>
      </div>
    </section>
  );
}

export default ProfileComplete;
